export enum EmotionEpisodeStatusTypes {
  new = 'new',
  shallow_mapped = 'shallow_mapped',
  in_shallow_map_review = 'in_shallow_map_review',
  shallow_map_reviewed = 'shallow_map_reviewed',
  fully_mapped = 'fully_mapped',
  in_review = 'in_review',
  reviewed = 'reviewed'
}
